export function createBidirectionalMap(mappings) {
    const forward = Object.fromEntries(mappings);
    const reverse = Object.fromEntries(mappings.map(([key, value]) => [value, key]));
    return { forward, reverse };
}
//# sourceMappingURL=createBidirectionalMap.js.map